import Layout from './components/Layout'
import Portal from './components/Portal'
import Members from './components/Members'
import Profile from './components/Profile'
import ErrorPage from './components/ErrorPage'

const routes = [
  { path: '/', exact: true, name: 'Home', element: Layout },
  { path: '/portals', name: 'Portals', element: Portal },
  { path: '/members', name: 'Members', element: Members },
  { path: '/profile', name: 'Profile', element: Profile },
  { path: '/error', name: 'Error', element: ErrorPage },
]

export default routes
